var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import Button from "@irati/ui/src/Button";
import { calculateCountdown } from "@irati/deals/helpers/deals/countdown";
import { H4 } from "@irati/ui/src/Typography";
import Countdown from "../Countdown";
import { Container } from "../styled";
import PerkAvailableBlock from "../PerkAvailableBlock";
var PerkNotAvailableBlock = /** @class */ (function (_super) {
    __extends(PerkNotAvailableBlock, _super);
    function PerkNotAvailableBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            days: 0,
            hours: 0,
            min: 0,
            sec: 0
        };
        return _this;
    }
    PerkNotAvailableBlock.prototype.componentDidMount = function () {
        var _this = this;
        // update every second
        this.interval = setInterval(function () {
            var date = calculateCountdown(_this.props.availableDate);
            if (date) {
                _this.setState(date);
            }
            else {
                _this.stop();
            }
        }, 1000);
        setTimeout(function () {
            _this.setState({ load: Promise.resolve() });
        }, 1000);
    };
    PerkNotAvailableBlock.prototype.componentWillUnmount = function () {
        this.stop();
    };
    PerkNotAvailableBlock.prototype.stop = function () {
        clearInterval(this.interval);
    };
    PerkNotAvailableBlock.prototype.render = function () {
        var _a = this.props, redeemHeaderEmoji = _a.redeemHeaderEmoji, redeemButtonText = _a.redeemButtonText, redeemButtonDisabled = _a.redeemButtonDisabled, onClickRedeem = _a.onClickRedeem;
        var _b = this.state, load = _b.load, days = _b.days, hours = _b.hours, min = _b.min, sec = _b.sec;
        return (React.createElement(Container, null,
            React.createElement(Loading, { load: load }, days === 0 && hours === 0 && min === 0 && sec === 0 ? (React.createElement(PerkAvailableBlock, { redeemHeaderEmoji: redeemHeaderEmoji, redeemButtonText: redeemButtonText, redeemButtonDisabled: redeemButtonDisabled, onClickRedeem: onClickRedeem })) : (React.createElement(React.Fragment, null,
                React.createElement(H4, { textAlign: "center" },
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.perkNotAvailableBlock.header" })),
                React.createElement(Countdown, { days: days, hours: hours, min: min, sec: sec }),
                React.createElement(Button, { large: true, full: true, disabled: true },
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.perkNotAvailableBlock.buttonText" })))))));
    };
    return PerkNotAvailableBlock;
}(PureComponent));
export default injectIntl(PerkNotAvailableBlock);
